import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { PurchaseItemsProps } from "../../types/purchaseItem";

export interface PurchaseItemsState {
  purchaseItems: PurchaseItemsProps[];
  totalPurchaseItems: number;
  isPurchaseItemModalOpen: boolean;
  editPurchaseItem: PurchaseItemsProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: PurchaseItemsState = {
  purchaseItems: [],
  totalPurchaseItems: 0,
  isPurchaseItemModalOpen: false,
  editPurchaseItem: null,
  loading: false,
  error: null,
};

type FetchPurchaseItemsListDataProps = {
  page: number;
  size?: number;
  fromDate?: string | null;
  toDate?: string | null;
  search?: string | null;
};

export const fetchPurchaseItemsListData = createAsyncThunk(
  "fetchPurchaseItemsListData",
  async (req: FetchPurchaseItemsListDataProps) => {
    let response: any;
    await GET(`/v1/admin/purchase-items`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const purchaseItemsSlice = createSlice({
  name: "purchaseItems",
  initialState,
  reducers: {
    togglePurchaseItemModal: (state, action: PayloadAction<boolean>) => {
      state.isPurchaseItemModalOpen = action.payload;
    },
    setEditPurchaseItem: (
      state,
      action: PayloadAction<PurchaseItemsProps | null>
    ) => {
      state.editPurchaseItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchPurchaseItemsListData.pending,
      (state, action: any) => {
        state.purchaseItems = [];
        state.loading = true;
        state.error = null;
      }
    );
    builder.addCase(
      fetchPurchaseItemsListData.fulfilled,
      (state, action: any) => {
        state.loading = false;
        if (action.payload.data.status === "success") {
          state.purchaseItems = action.payload.data.data.records;
          state.totalPurchaseItems = action.payload.data.data.total_records;
          state.error = null;
        } else {
          state.purchaseItems = [];
          state.error =
            action?.payload?.data?.message ||
            "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
        }
      }
    );
    builder.addCase(
      fetchPurchaseItemsListData.rejected,
      (state, action: any) => {
        state.purchaseItems = [];
        state.loading = false;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    );
  },
});

export const { togglePurchaseItemModal, setEditPurchaseItem } =
  purchaseItemsSlice.actions;

export const getPurchaseItems = (state: RootState) =>
  state.purchaseItems.purchaseItems;

export const getTotalPurchaseItems = (state: RootState) =>
  state.purchaseItems.totalPurchaseItems;

export const getIsPurchaseItemModalOpen = (state: RootState) =>
  state.purchaseItems.isPurchaseItemModalOpen;

export const getEditPurchaseItem = (state: RootState) =>
  state.purchaseItems.editPurchaseItem;

export default purchaseItemsSlice.reducer;
